<template>
  <div class="hello">
    <Navbar></Navbar>
    <h4
      class="card-title"
      style="padding-top:30px;padding-bottom:30px;background-color:#c3c3c338;"
    >Mobile App</h4>
    <div class="container">
      <div
        id="loadingmessage"
        style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
        v-if="loading"
      >
        <p style="position: absolute; color: White; top: 40%; left: 40%;">
          <img src="../assets/animation.gif" />
        </p>
      </div>
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <img src="../assets/serpant.png" width="40%" height="auto" />
        </div>
        <div class="col-md-3"></div>
        <div class="col-md-12">
          <p style="text-align:justify;font-size:18px;">
            <b>SERPENT ( Snake Emergency Response Programme & Response Tool )</b>
 is a critical information management system which use both mobile and server based technology to connect various stakeholders in Realtime to deal with emergencies regarding snakes and snake bites. The mobile app is free to download and use and aimed to save lives of people and wildlife.
          </p>
        </div>
         <div class="col-md-12">
              <h3 style="float:left;">
                <b>SERPENT: STATUS REPORT - {{today}}</b>
              </h3>
            </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-8">
              <br>
              <div class="card">
                <div class="card-body" style="text-align:center;background-color: #02b7ca;">
                  <b>App Users</b>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <br>
              <div class="card">
                <div class="card-body" style="text-align:center;background-color: #02b7ca;">
                  <b>{{items.count_total_users}}</b>
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <br>
              <div class="card">
                <div class="card-body" style="text-align:center;background-color: #02b7ca;">
                  <b>Snakes Rescued</b>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <br>
              <div class="card">
                <div class="card-body" style="text-align:center;background-color: #02b7ca;">
                  <b>{{items.count_total_locations}}</b>
                </div>
              </div>
            </div>

            <div class="col-md-8">
              <br>
              <div class="card">
                <div class="card-body" style="text-align:center;background-color: #02b7ca;">
                  <b>ISRN Members</b>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <br>
              <div class="card">
                <div class="card-body" style="text-align:center;background-color: #02b7ca;">
                  <b>{{items.count_total_rescuer}}</b>
                </div>
              </div>
            </div>

            <div class="col-md-8">
              <br>
              <div class="card">
                <div class="card-body" style="text-align:center;background-color: #02b7ca;">
                  <b>Listed Treatment Hospitals</b>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <br>
              <div class="card">
                <div class="card-body" style="text-align:center;background-color: #02b7ca;">
                  <b>{{items.count_hospital}}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <a
            href="https://play.google.com/store/apps/details?id=leopard.tech.lab.big4mapper&hl=en"
            target="_blank"
          >
            <img src="../assets/download.png" width="40%" height="auto">
          </a>
          <br><br>
          <iframe width="100%" height="70%" src="https://www.youtube.com/embed/9u1v0SmlmOQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
import Navbar from "./navbar";
export default {
  name: "Images",
  components: {
    Navbar
  },
  data() {
    return {
      items: "",
      loading: false,
      today: ""
    };
  },
  methods: {
    loadData: function() {
      this.loading = true;
      axios({
        url: "https://api.indiansnakes.org/user/stats",
        method: "GET"
      })
        .then(response => {
          this.items = response.data.data;
          this.loading = false;
        })
        .catch(e => {
          this.errors.push(e);
          this.loading = false;
        });
    }
  },
  mounted: function() {
    this.loadData();
    this.today = new Date();
    var dd = String(this.today.getDate()).padStart(2, "0");
    var mm = String(this.today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = this.today.getFullYear();

    this.today = dd + "/" + mm + "/" + yyyy;
  }
};
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>